<template>
<Teleport to="body">
  <div class="fixed inset-0 z-50 flex justify-center bg-black/60">
    <div class="m-5  w-full md:w-8/12 lg:w-6/12" @click.self="closeDialog(false)" >

      <div class="p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">
        
        <div class="flex flex-col w-full text-black">
        
          <BlockUI :visible="blocked">

            <div v-if="blocked" class="absolute inset-0 flex items-center justify-center z-50 bg-black/20">
              <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5" fill="transparent" animationDuration=".5s" />
            </div>

            <div class="flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]">
              <div>
                <font-awesome-icon :icon="['fas', 'fa-universal-access']" class="w-6 h-6 text-white" />
              </div>
              <div class="font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis"> 
                {{ $t('titulo.editar.datos.personales') }}
              </div>
            </div>


            <Form :validation-schema="schema" @invalid-submit="onInvalidSubmit">

              <div class="container p-4 text-left">

                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
                  <div class="w-full px-2">
                    <label class="block mb-1">{{ $t('label.dni') }}</label>
                    <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
                      <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.dni')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                      <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
                    </Field>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
                  <div class="w-full px-2 md:w-6/12">
                    <label class="block mb-1">{{ $t('label.nombre') }}</label>
                    <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
                      <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.nombre')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                      <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
                    </Field>
                  </div>
                  <div class="w-full px-2 md:w-6/12">
                    <label class="block mb-1">{{ $t('label.apellido') }}</label>
                    <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
                      <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.apellido')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                      <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
                    </Field>
                  </div>
                </div>
                
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
                  <div class="w-full px-2 md:w-6/12">
                    <label class="block mb-1">{{ $t('label.cargo') }}</label>
                    <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
                      <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.cargo')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                      <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
                    </Field>
                  </div>
                  <div class="w-full px-2 md:w-6/12">
                    <label class="block mb-1">{{ $t('label.telefono') }}</label>
                    <Field name="telefono" v-slot="{ field, errors }" v-model="formData.telefono">
                      <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.telefono')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                      <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefono" /></span>
                    </Field>
                  </div>
                </div>
              </div>

            </Form>

            <div class="p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-5 bg-gray-100">
              <a @click="closeDialog(false)" class="cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                <font-awesome-icon :icon="['fas', 'fa-xmark']" /> {{ $t('boton.cancelar') }}
              </a>
              <a @click="aplicarCambios" class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                <font-awesome-icon :icon="['fas', 'fa-check-double']" /> {{ $t('boton.aplicar.cambios') }}
              </a>
            </div>
          </BlockUI>


        </div>
      </div>

    </div>
  </div>
</Teleport>  

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent, PropType } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';

import Swal from 'sweetalert2'
import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';

import { ConfiguracionMeeting } from 'qreventos-suite/src/services/suite.interfaces';
import seguridadServices from '@/services/seguridad.services';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import suiteService, { Acreditado } from 'qreventos-suite/services';
import { UPDATE } from 'qreventos-suite/constantes';
import meetingService from 'qreventos-suite/meeting';


export default defineComponent({
  components: {
    InputText, BlockUI, ProgressSpinner,
    Field, ErrorMessage, Form
  },
  props: {
    closeFunction: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      blocked: false,
      acreditado: undefined as unknown as Acreditado,
      formData: {
        dni: '',
        nombre: '',
        apellido: '', 
        cargo: '',
        telefono: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required(this.$t('errors.dni.required')).min(6, this.$t('errors.dni.min')),
        nombre: yup.string().required(this.$t('errors.name.required')).min(3, this.$t('errors.name.min')),
        apellido: yup.string().required(this.$t('errors.lastname.required')).min(3, this.$t('errors.lastname.min')),
        cargo: yup.string().required(this.$t('errors.cargo.required')).min(3, this.$t('errors.cargo.min')),
      });
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: this.$t("error.revise") + " " + errores, icon: "error"});
    },
    closeDialog(reloadList: boolean = false) {
      if (this.closeFunction) {
        this.closeFunction(reloadList);
      }
    },    
    async fillAcreditado() {
      try {        
        this.blocked = true;
        const hash: string = seguridadServices.getLocalHash() as string;
        const configuracionMeeting:ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        this.acreditado = await meetingService.findAcreditadoMeetingBy(configuracionMeeting.evento.id, hash);

        this.formData.dni = this.acreditado.dni;
        this.formData.nombre = this.acreditado.nombre;
        this.formData.apellido = this.acreditado.apellido;
        this.formData.telefono = this.acreditado.telefono;
        this.formData.cargo = this.acreditado.cargo;

      } catch (error) {
        this.blocked = false;
          Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.blocked = false;
      }    
    },    
    async aplicarCambios() {
      try {
        this.blocked = true;

        const configuracionMeeting:ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

        this.acreditado.dni = this.formData.dni;
        this.acreditado.nombre = this.formData.nombre;
        this.acreditado.apellido = this.formData.apellido;
        this.acreditado.telefono = this.formData.telefono;
        this.acreditado.cargo = this.formData.cargo;

        this.acreditado.modificado = UPDATE;
        await suiteService.saveOrUpdate(configuracionMeeting.evento.id, this.acreditado);
        this.closeDialog(true);
        
      }
      catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: 'Error [' + error + ']', icon: "error" });
      } finally {
        this.blocked = false;
      }
    }, 
  },
  async mounted() {
    document.body.style.overflow = "hidden";
    await this.fillAcreditado();
  },
  unmounted() {
    document.body.style.overflow = "";
  }  
});
</script>